import * as am5 from "@amcharts/amcharts5";

export function applyAmChartsLicense() {
  am5.addLicense("AM5C303320341");
}